import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_home')}
          </button>
          <button
            onClick={() => {
              const gallery = document.querySelector('section');
              if (gallery) gallery.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_gallery')}
          </button>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Luxury Villa Arcisate. {t('footer_rights')}
            </p>
            <div className="flex items-center gap-2">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors text-sm whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
